import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=1f276c64&scoped=true&"
import script from "./NewsletterModal.vue?vue&type=script&lang=js&"
export * from "./NewsletterModal.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterModal.vue?vue&type=style&index=0&id=1f276c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f276c64",
  null
  
)

export default component.exports